import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button, Card, CardMedia, Grid } from '@mui/material'
import { observer } from 'mobx-react';
import { toJS } from 'mobx';
import { useStore } from '../../../state/MobxContext';
import { makeStyles, useMediaQuery } from "@material-ui/core";
import Box from '@mui/material/Box';
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";


function ProductCard(props) {

  // console.log("props", props);
  const { SaleStore } = useStore();




  const useStyles = makeStyles((theme) => ({
    //BrandImage
    BrandImage: {
      // whiteSpace: "nowrap",
      // objectFit: "cover",
      width: '100%',
      height: "8rem"
    },
    //BrandiamgeSlide
    BrandiamgeSlide: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }));

  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width: 600px)");


  const BrandTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.7rem',
        alignItems: 'center',
        justifyContent: "center"
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
        alignItems: 'center',
        justifyContent: "center"
      }
  })(Typography);

  const GoodsNameTypographyMobile = withStyles({
    root: isMobile ?
      {
        color: "#FFFFFF",
        fontSize: '0.7rem',
        alignItems: 'center',
        justifyContent: "center"
      }
      :
      {
        color: "#FFFFFF",
        fontSize: '1rem',
        alignItems: 'center',
        justifyContent: "center"
      }
  })(Typography);

  return (
    <Card key={props.item.Index}
      sx={isMobile ? { bgcolor: "black", maxWidth: 90, m: 1, boxShadow: 10, marginBottom: "1rem" } : { bgcolor: "black", maxWidth: 170, m: 2, boxShadow: 10 }} >
      <CardMedia
        component="img"
        sx={isMobile ? { bgcolor: 'white', height: 90 } : { bgcolor: 'white', height: 170 }}
        image={props.item.image}
        alt={props.item.goods_name}
        onClick={() => { SaleStore?.setBranditemChack(props.item) }}
      />
      <Grid container direction='row' justifyContent='center' alignItems='center' onClick={() => { SaleStore?.setBranditemChack(props.item) }} >
        <GoodsNameTypographyMobile>
          {props.item.goods_name}
        </GoodsNameTypographyMobile>
      </Grid>
    </Card>
  )
}

export default observer(ProductCard);
